import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import styled from "styled-components";
import ListComponent from "../../components/ListComponent";

const data = [
    {
        id: 1,
        class: 'Architecture 101',
        title: 'Introduction to Architectural Design',
        instructor: 'Prof. Elizabeth Moore',
        duration: '50 minutes',
        date: 'September 5, 2024',
        room: 'Room 204, Main Building',
        summary: 'An introductory lecture on the basic principles of architectural design, including form, function, and aesthetics.',
        topics: [
            'Basic Design Principles',
            'Form and Function in Architecture',
            'Introduction to Aesthetics',
            'Case Studies of Famous Designs'
        ]
    },
    {
        id: 2,
        class: 'History of Architecture',
        title: 'Romanesque to Gothic Architecture',
        instructor: 'Dr. Robert Harris',
        duration: '60 minutes',
        date: 'September 7, 2024',
        room: 'Room 302, History Wing',
        summary: 'A lecture on the transition from Romanesque to Gothic architecture, focusing on key features and notable structures.',
        topics: [
            'Characteristics of Romanesque Architecture',
            'The Emergence of Gothic Architecture',
            'Key Gothic Structures',
            'Impact of Gothic Architecture on European Cities'
        ]
    },
    {
        id: 3,
        class: 'Environmental Design',
        title: 'Sustainable Architecture Practices',
        instructor: 'Dr. Lisa Chang',
        duration: '55 minutes',
        date: 'September 10, 2024',
        room: 'Room 115, Green Building',
        summary: 'This lecture covers the principles of sustainable architecture, with a focus on eco-friendly materials and energy-efficient design.',
        topics: [
            'Principles of Sustainable Design',
            'Eco-friendly Building Materials',
            'Energy-efficient Systems',
            'Case Studies of Sustainable Projects'
        ]
    },
    {
        id: 4,
        class: 'Urban Planning',
        title: 'Principles of Urban Design',
        instructor: 'Prof. David Lee',
        duration: '50 minutes',
        date: 'September 12, 2024',
        room: 'Lecture Hall A, Urban Studies Center',
        summary: 'An overview of the core principles of urban design, including the layout of public spaces, transportation systems, and zoning.',
        topics: [
            'Fundamentals of Urban Planning',
            'Designing Public Spaces',
            'Transportation and Infrastructure',
            'Zoning and Land Use Planning'
        ]
    },
    {
        id: 5,
        class: 'Digital Architecture',
        title: 'Introduction to 3D Modeling',
        instructor: 'Prof. Michael Clark',
        duration: '45 minutes',
        date: 'September 15, 2024',
        room: 'Computer Lab 1, Technology Wing',
        summary: 'This lecture introduces the basics of 3D modeling software used in architectural design, including hands-on practice.',
        topics: [
            'Basics of 3D Modeling',
            'Introduction to Modeling Software',
            'Creating Simple 3D Models',
            'Applications of 3D Models in Architecture'
        ]
    }
];


const PublicLecture = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | Class Lecture</title>
                <meta name="Architech Shamsul Wares"
                      content="Our current mode and depiction of existence become almost incomprehensible due to the explosion of unimaginable visual."/>
            </Helmet>
            <StyledComponent>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <ListComponent url={'typology'} data={data} />
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`


`;

export default PublicLecture;
